module.exports = {"minLength":5,"digitRequired":true,"upperCaseCharacterRequired":true,"specialCharacterRequired":true}


//////////////////
// WEBPACK FOOTER
// ./src/assets/configuration/config.json
// module id = pfoN
// module chunks = 0